/* This file was GENERATED from the Webflow capture, which has since been
 * retired — see DESIGN-SYSTEM-PLAN.md. There is no generator any more: this is
 * now ordinary source, and editing it by hand is how you change it.
 * Ported element-for-element from mirror/about/index.html.
 * Nothing here is interpreted: every element, class and attribute is the
 * capture's own. The shared header, promo strip and footer are rendered around
 * this by SiteChrome; behaviour that needs JS comes from the interaction
 * components, not from rewriting this markup.
 */
import { Link } from 'react-router'
import { BottomCTA } from '@/components/sections/BottomCTA'

export default function AboutPage() {
  return (
    <>
      <section className={"section-container section-padding-full page-hero"}>
        <div className={"page-hero-wrapper maxwidthlarge"}>
          <h1 className={"center"}>
            The future of marketing operations.
          </h1>
          <p className={"large-text center maxwidthmedium"}>
            The most reliable way to create hyper-segmented and hyper-personalized messaging at scale.
          </p>
          <div className={"w-layout-hflex button-lockup"}>
            <Link to={"/demo"} className={"button button-primary w-button"}>
              Book demo
            </Link>
          </div>
        </div>
      </section>
      <img className={"image-32"} src={"/media/67e99d1298c376b972c6d7c4_aboutribbon2.png"} alt="" style={{  }} sizes={"100vw"} data-w-id={"74590e3d-9a7c-9a3b-2ea8-727d2a266e61"} loading={"lazy"} srcSet={"/media/67e99d1298c376b972c6d7c4_aboutribbon2-p-500.png 500w, /media/67e99d1298c376b972c6d7c4_aboutribbon2-p-800.png 800w, /media/67e99d1298c376b972c6d7c4_aboutribbon2-p-1080.png 1080w, /media/67e99d1298c376b972c6d7c4_aboutribbon2-p-1600.png 1600w, /media/67e99d1298c376b972c6d7c4_aboutribbon2-p-2000.png 2000w, /media/67e99d1298c376b972c6d7c4_aboutribbon2-p-2600.png 2600w, /media/67e99d1298c376b972c6d7c4_aboutribbon2-p-3200.png 3200w, /media/67e99d1298c376b972c6d7c4_aboutribbon2.png 5624w"} />
      <div className={"section-container section-padding-full"}>
        <div className={"w-layout-vflex section-wrapper stack small"}>
          <h3 className={"nomargin"}>
            Hi, we're Singulate.
          </h3>
          <div className={"w-richtext"}>
            <p>
              We started Singulate because we experienced a big marketing problem at our previous company: we had tons of data on our customers but it was too manual and time-consuming to use this data to meaningfully personalize our messaging and nurture them through our funnel. So we sent email blasts and automations with static personalization tokens (e.g., [FNAME] 😩) sprinkled in — 99% of the content was the same for everyone, leaving millions in growth on the table.
            </p>
            <p>
              So we created Singulate, the easiest way to segment audiences and individualize content at scale. Singulate’s difference is 
              <span className={"text-span-4"}>
                relevance-personalization
              </span>
              . You can create content for each contact in a way that’s far more relevant than ever before — not with AI-writing, but in a more reliable and human-driven way. The best personalization is invisible. And it works. Singulate saves marketing ops teams 40+ hours per week and drives 2-7X increases in engagement. Come see what we're building and get a glimpse into the future of marketing operations.
            </p>
          </div>
        </div>
      </div>
      <div className={"section-container section-padding-full gray-background"}>
        <div className={"section-wrapper stack center double-gap"}>
          <div className={"w-layout-vflex flex-block-31 center"}>
            <div className={"mono-component-title"}>
              3 pillars
            </div>
            <h3 className={"nomargin"}>
              How we build
            </h3>
            <div className={"large-text"}>
              These principles guide our product decisions
            </div>
          </div>
          <div className={"w-layout-vflex image-text-grid"}>
            <div className={"image-text-callout"}>
              <img src={"/media/66fd8874c82d2044426cf2b4_sophisticated-simple.svg"} loading={"lazy"} alt="" className={"icon-text-callout-image"} />
              <div className={"div-block-48"}>
                <h5 className={"nomargin center"}>
                  Make sophisticated simple
                </h5>
                <p>
                  Make what was complex and hard to do 90% easier and faster.
                </p>
              </div>
            </div>
            <div className={"image-text-callout stack center"}>
              <img src={"/media/66fd888e3d513842be11f9d3_relevance-scale.svg"} loading={"lazy"} alt="" className={"icon-text-callout-image"} />
              <div className={"div-block-48"}>
                <h5 className={"nomargin center"}>
                  Relevance at scale
                </h5>
                <p>
                  Recover the nuance and depth of a 1:1 conversation when communicating at scale.
                </p>
              </div>
            </div>
            <div className={"image-text-callout stack center"}>
              <img src={"/media/66fe19b7ff6d875cf4348662_Singulate-mailchimp.svg"} loading={"lazy"} alt="" className={"icon-text-callout-image"} />
              <div className={"div-block-48"}>
                <h5 className={"nomargin center"}>
                  Confident operators
                </h5>
                <p>
                  Take the stress out of big swings that make a huge impact on growth.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={"section-container section-padding-full"}>
        <div className={"section-wrapper"}>
          <div className={"content-block animated-border darkborder center double-gap"}>
            <div className={"w-layout-vflex flex-block-33"}>
              <div className={"mono-component-title"}>
                About Us
              </div>
              <h3 className={"nomargin center"}>
                Founding team
              </h3>
              <div className={"large-text center"}>
                We are a 100% remote and international team, headquartered in the USA
              </div>
            </div>
            <div className={"image-text-grid"}>
              <div className={"image-text-callout"}>
                <div className={"image-text-stack-image"}>
                  <img src={"/media/66c84d04a576f5d618888ea7_dave@2x.png"} loading={"lazy"} sizes={"(max-width: 776px) 100vw, 776px"} srcSet={"/media/66c84d04a576f5d618888ea7_dave@2x-p-500.png 500w, /media/66c84d04a576f5d618888ea7_dave@2x.png 776w"} alt="" className={"team-img"} />
                </div>
                <div className={"image-text-stack-info"}>
                  <h6 className={"center nomargin"}>
                    Dave Schools
                  </h6>
                  <div className={"position-name"}>
                    Cofounder & CEO
                  </div>
                  <div className={"position-name"}>
                    Baltimore, MD
                  </div>
                </div>
              </div>
              <div className={"image-text-callout"}>
                <div className={"image-text-stack-image"}>
                  <img src={"/media/66c84da46a38d4b5506b4e96_nick@2x.png"} loading={"lazy"} sizes={"(max-width: 776px) 100vw, 776px"} srcSet={"/media/66c84da46a38d4b5506b4e96_nick@2x-p-500.png 500w, /media/66c84da46a38d4b5506b4e96_nick@2x.png 776w"} alt="" className={"team-img"} />
                </div>
                <div className={"image-text-stack-info"}>
                  <h6 className={"center nomargin"}>
                    Nicolas Klein
                  </h6>
                  <div className={"position-name"}>
                    Cofounder & COO/CPO
                  </div>
                  <div className={"position-name"}>
                    London, UK
                  </div>
                </div>
              </div>
              <div className={"image-text-callout"}>
                <div className={"image-text-stack-image"}>
                  <img src={"/media/66c84da4363ddb43bda0946c_john@2x.png"} loading={"lazy"} sizes={"(max-width: 776px) 100vw, 776px"} srcSet={"/media/66c84da4363ddb43bda0946c_john@2x-p-500.png 500w, /media/66c84da4363ddb43bda0946c_john@2x.png 776w"} alt="" className={"team-img"} />
                </div>
                <div className={"image-text-stack-info"}>
                  <h6 className={"center nomargin"}>
                    John O’Gara
                  </h6>
                  <div className={"position-name"}>
                    Cofounder & CTO
                  </div>
                  <div className={"position-name"}>
                    Lisbon, Portugal
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={"section-container section-padding-full dark"}>
        <div className={"section-wrapper stack center double-gap"}>
          <div className={"w-layout-vflex flex-block-31 center"}>
            <div className={"mono-component-title white"}>
              PARTNERS
            </div>
            <h3 className={"nomargin white"}>
              Investors & Advisors
            </h3>
          </div>
          <div className={"container investors"}>
            <div className={"investors-wrapper"}>
              <img src={"/media/67eb0a996494b8d8fcc3f669_bowery-capital.svg"} loading={"lazy"} alt="" className={"image-34"} />
              <img src={"/media/67eb0ae85e973c917b40e342_seedcamp.svg"} loading={"lazy"} alt="" className={"image-35"} />
            </div>
            <div data-w-id={"76a6b1dd-29c9-1abd-5b1a-d75f64e961ad"} style={{  }} className={"fade-white center small-text"}>
              Including the founders of Hopin, Indeed.com, Saastock, Tola, Trackmaven, and more. 
            </div>
          </div>
          <div className={"w-layout-vflex image-text-grid _6"}>
            <div id={"w-node-_7f5b1f36-2138-335f-5db7-358c5687e1a0-2102eeda"} className={"advisor-card"}>
              <img src={"/media/67eb027ec31e11d8ac01f543_Frame 1948759564.jpg"} loading={"lazy"} sizes={"(max-width: 600px) 100vw, 600px"} srcSet={"/media/67eb027ec31e11d8ac01f543_Frame 1948759564-p-500.jpg 500w, /media/67eb027ec31e11d8ac01f543_Frame 1948759564.jpg 600w"} alt="" className={"icon-text-callout-image round"} />
              <div className={"follower-bubble"}>
                <img src={"/media/670422b19c9f66fd53d5ee4d_linkedin.svg"} loading={"lazy"} alt="" className={"image-33"} />
                <p className={"small-text white nomargin"}>
                  142k followers
                </p>
              </div>
              <div className={"div-block-48"}>
                <h5 className={"nomargin white center"}>
                  Daniel Murray
                </h5>
                <p className={"nomargin center small-text fade-white"}>
                  Founder, Authority, The Marketing Millennials
                </p>
              </div>
            </div>
            <div id={"w-node-e0abd294-fe6d-725d-be51-69ae94a2781b-2102eeda"} className={"advisor-card"}>
              <img src={"/media/67eb02d78a91f42e8baa988c_Frame 1244831212.jpg"} loading={"lazy"} sizes={"(max-width: 600px) 100vw, 600px"} srcSet={"/media/67eb02d78a91f42e8baa988c_Frame 1244831212-p-500.jpg 500w, /media/67eb02d78a91f42e8baa988c_Frame 1244831212.jpg 600w"} alt="" className={"icon-text-callout-image round"} />
              <div className={"follower-bubble"}>
                <img src={"/media/670422b19c9f66fd53d5ee4d_linkedin.svg"} loading={"lazy"} alt="" className={"image-33"} />
                <p className={"small-text white nomargin"}>
                  28k followers
                </p>
              </div>
              <div className={"div-block-48"}>
                <h5 className={"nomargin white center"}>
                  Dahlia El Gazzar
                </h5>
                <p className={"small-text nomargin center fade-white"}>
                  Founder, DAHLIA+Agency
                </p>
              </div>
            </div>
            <div id={"w-node-_35de6d13-2b7e-9ef1-ece6-4bd150bbba43-2102eeda"} className={"advisor-card"}>
              <img src={"/media/67eb02ed49626dfa55045b02_Profile Image.jpg"} loading={"lazy"} sizes={"(max-width: 600px) 100vw, 600px"} srcSet={"/media/67eb02ed49626dfa55045b02_Profile Image-p-500.jpg 500w, /media/67eb02ed49626dfa55045b02_Profile Image.jpg 600w"} alt="" className={"icon-text-callout-image round"} />
              <div className={"follower-bubble"}>
                <img src={"/media/670422b19c9f66fd53d5ee4d_linkedin.svg"} loading={"lazy"} alt="" className={"image-33"} />
                <p className={"small-text white nomargin"}>
                  59k followers
                </p>
              </div>
              <div className={"div-block-48"}>
                <h5 className={"nomargin white center"}>
                  Jay Schwedelson
                </h5>
                <p className={"small-text nomargin center fade-white"}>
                  Founder, President & CEO, SubjectLine, GURU Media Hub, Outcome Media
                </p>
              </div>
            </div>
            <div id={"w-node-_0251d880-eb20-74bf-ea43-ec5b51a1b767-2102eeda"} className={"advisor-card"}>
              <img src={"/media/67eb0300aab17cfd38e2cb73_Robin Daniels Headshot 2.jpg"} loading={"lazy"} sizes={"(max-width: 600px) 100vw, 600px"} srcSet={"/media/67eb0300aab17cfd38e2cb73_Robin Daniels Headshot 2-p-500.jpg 500w, /media/67eb0300aab17cfd38e2cb73_Robin Daniels Headshot 2.jpg 600w"} alt="" className={"icon-text-callout-image round"} />
              <div className={"follower-bubble"}>
                <img src={"/media/670422b19c9f66fd53d5ee4d_linkedin.svg"} loading={"lazy"} alt="" className={"image-33"} />
                <p className={"small-text white nomargin"}>
                  42k followers
                </p>
              </div>
              <div className={"div-block-48"}>
                <h5 className={"nomargin white center"}>
                  Robin Daniels
                </h5>
                <p className={"small-text nomargin center fade-white"}>
                  Chief Business & Product Officer, Zensai
                </p>
              </div>
            </div>
            <div id={"w-node-_7b638563-11ae-5d49-28e9-5147b1321192-2102eeda"} className={"advisor-card"}>
              <img src={"/media/67eb030e80dd7538b7e2bc9a_Ross Simmonds Headshot 2.jpg"} loading={"lazy"} sizes={"(max-width: 600px) 100vw, 600px"} srcSet={"/media/67eb030e80dd7538b7e2bc9a_Ross Simmonds Headshot 2-p-500.jpg 500w, /media/67eb030e80dd7538b7e2bc9a_Ross Simmonds Headshot 2.jpg 600w"} alt="" className={"icon-text-callout-image round"} />
              <div className={"follower-bubble"}>
                <img src={"/media/670422b19c9f66fd53d5ee4d_linkedin.svg"} loading={"lazy"} alt="" className={"image-33"} />
                <p className={"small-text white nomargin"}>
                  46k followers
                </p>
              </div>
              <div className={"div-block-48"}>
                <h5 className={"nomargin white center"}>
                  Ross Simmonds
                </h5>
                <p className={"small-text nomargin center fade-white"}>
                  CEO, Foundation & Distribution.ai
                </p>
              </div>
            </div>
            <div id={"w-node-_0b26583e-a9b3-c8d4-9b4b-bea282632341-2102eeda"} className={"advisor-card"}>
              <img src={"/media/67eb032511669d4375305509_Ryan Bonnici Headshot 2.jpg"} loading={"lazy"} sizes={"(max-width: 600px) 100vw, 600px"} srcSet={"/media/67eb032511669d4375305509_Ryan Bonnici Headshot 2-p-500.jpg 500w, /media/67eb032511669d4375305509_Ryan Bonnici Headshot 2.jpg 600w"} alt="" className={"icon-text-callout-image round"} />
              <div className={"follower-bubble"}>
                <img src={"/media/670422b19c9f66fd53d5ee4d_linkedin.svg"} loading={"lazy"} alt="" className={"image-33"} />
                <p className={"small-text white nomargin"}>
                  43k followers
                </p>
              </div>
              <div className={"div-block-48"}>
                <h5 className={"nomargin white center"}>
                  Ryan Bonnici
                </h5>
                <p className={"small-text nomargin center fade-white"}>
                  CMO, Wellhub
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <BottomCTA />
    </>
  )
}
